import { Injectable } from '@angular/core';
import { DocumentService } from '../services/document.service';
import { UsersService } from '../../shared/services/users.service';
import { ResponsibleSubBUService } from '../../shared/services/responsible-sub-bu.service';
import { map, Observable, of, shareReplay, tap } from 'rxjs';
import { cloneDeep } from 'lodash-es';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../shared/constants/api-constants';
@Injectable({
  providedIn: 'root',
})
export class DocumentMasterDataService {
  eQMSScopesForDocumentSearch: IEQMSScopeLookUpDetails[] = [];
  eQMSScopesForDocument: IEQMSScopeLookUpDetails[] = [];
  resposibleSubBUList: any = [];
  usersList: any = [];
  documentMastersData: any = {};

  constructor(
    private documentsservice: DocumentService,
    private usersService: UsersService,
    private subBUService: ResponsibleSubBUService,
    private httpClient:HttpClient
  ) {}

  getsubBuMasterData(): Observable<any> {
    //need to change here
    if (this.resposibleSubBUList.length === 0) {
      return this.subBUService.getSubBU().pipe(
        map((subBuData) => {
          for (let dataItem of subBuData) {
            this.resposibleSubBUList.push({
              value: dataItem.Code + ' ' + dataItem.Name,
              name: `${dataItem.Code} ${dataItem.Name}`,
            });
          }
          return this.resposibleSubBUList;
        })
      );
    } else {
      return of(this.resposibleSubBUList);
    }
  }

  getUsersMasterData(): Observable<any> {
    if (this.usersList.length === 0) {
      return this.usersService.getUsers().pipe(
        map((usersData) => {
          for (let dataItem of usersData) {
            this.usersList.push({
              value: dataItem.name,
              name: dataItem.name,
            });
          } 
          return this.usersList;
        })
      );
    } else {
      return of(this.usersList);
    }
  }

  getDocumentMasterData(): Observable<any> {
    let observable: Observable<any>;
    if (Object.keys(this.documentMastersData).length === 0) {
      observable = this.documentsservice.getDocumentdetails().pipe(
        map((serviceData) => {
          this.documentMastersData = cloneDeep(serviceData);
          this.documentMastersData.categories = this.getListWithNameCodeAsName(
            this.documentMastersData.categories
          );
          this.documentMastersData.divisions = this.getListWithNameCodeAsName(
            this.documentMastersData.divisions
          );
          this.documentMastersData.functionalAreas =
            this.getListWithNameCodeAsName(
              this.documentMastersData.functionalAreas
            );
          this.documentMastersData.documentTypes =
            this.getListWithNameCodeAsName(
              this.documentMastersData.documentTypes
            );
          this.documentMastersData.localCategories =
            this.getListWithNameCodeAsName(
              this.documentMastersData.localCategories
            );
            return this.documentMastersData;
        })
      );
    } else {
      observable = of(this.documentMastersData);
    }
    return observable;
  }

  geteQMSScopesForDocumentSearch = (feature:string) => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForDocumentSearch.length > 0) {
      observable = of(this.eQMSScopesForDocumentSearch);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>(ApiConstants.EQMSScopesLookupForDocumentLibrary_Api + "/" + feature)
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForDocumentSearch = eQMSScopes)
        );
    }
    return observable;
  }
  geteQMSScopesForDocument = () => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForDocument.length > 0) {
      observable = of(this.eQMSScopesForDocument);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>(ApiConstants.EQMSScopesLookupForDocument_Api)
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForDocument = eQMSScopes)
        );
    }
    return observable;
  }
  private getListWithNameCodeAsName(dataList: any) {
    let listWithNameAndCodeValues: any = [];
    for (let dataItem of dataList) {
      listWithNameAndCodeValues.push({
        value: dataItem.code,
        name: `${dataItem.code} - ${dataItem.name}`,
      });
    }
    return listWithNameAndCodeValues;
  }
}
